export const Footer = () => {
    return (<footer>©Daniela.Doneva 2022</footer>)
}